export default "__VITE_ASSET__CNhd$B4d__"